import { add, get } from 'lodash';

export const mainurl = process.env.REACT_APP_MAINURL;
export const chatUrl = process.env.REACT_APP_CHATURL;

export const api = {
  // dashboard apis
  manage_property: `${mainurl}v1/crm/properties/get_properties`,
  get_property_status: `${mainurl}v1/crm/properties/get_property_status`,
  get_property_types: `${mainurl}v1/crm/properties/get_property_types`,
  get_property_features: `${mainurl}v1/crm/properties/get_features`,
  upload_property_img: `${mainurl}v1/crm/properties/upload_property_media`,
  upload_property_documents: `${mainurl}v1/crm/properties/upload_property_attachment`,
  add_property: `${mainurl}v1/crm/properties/add`,
  delete_property: `${mainurl}v1/crm/properties/delete_property`,
  edit_property: `${mainurl}v1/crm/properties/get_property_details`,
  upload_floor_image: `${mainurl}v1/crm/properties/upload_floor_image`,
  change_property_status: `${mainurl}v1/crm/properties/change_property_status`,
  change_featured_status: `${mainurl}v1/crm/properties/update_featured_status`,
  upload_stage_image: `${mainurl}v1/crm/properties/upload_stage_image`,
  get_inquiries: `${mainurl}v1/crm/inquiries/get_inquiries`,
  delete_inquiry: `${mainurl}v1/crm/inquiries/delete_inquiry`,
  add_edit_Inquiry: `${mainurl}v1/crm/inquiries/add_edit_inquiry`,
  get_property_dropdown: `${mainurl}v1/crm/properties/get_properties_for_dropdown`,
  review_rattings: `${mainurl}v1/crm/properties/get_review_ratings`,
  delete_review_rating: `${mainurl}v1/crm/properties/delete_review_rating`,
  get_states: `${mainurl}v1/crm/properties/get_states`,
  get_cities: `${mainurl}v1/crm/properties/get_cities`,
  add_cities: `${mainurl}v1/crm/properties/add_agent_state_city`,
  get_cities_table: `${mainurl}v1/crm/properties/get_agent_state_city`,
  delete_cities: `${mainurl}v1/crm/properties/delete_agent_state_city`,
  get_about_us_page: `${mainurl}v1/crm/about/get_about_page_content`,
  update_about_us_page: `${mainurl}v1/crm/about/add_edit_about`,
  markPropertyActive: `${mainurl}v1/crm/properties/mark_as_active`,
  add_edit_features_category: `${mainurl}v1/feature_category/add_edit_feature_category`,
  get_features_category: `${mainurl}v1/feature_category/get_feature_category`,
  delete_features_category: `${mainurl}v1/feature_category/delete_feature_category`,
  delete_feature_sub_category: `${mainurl}v1/feature_category/delete_feature_sub_category`,
  get_features_list: `${mainurl}v1/feature/get_feature_list`,
  add_edit_features_list: `${mainurl}v1/feature/add_edit_feature`,
  delete_features_list: `${mainurl}v1/feature/delete_feature`,
  get_features_category_dropdown: `${mainurl}v1/feature_category/get_feature_category`,
  get_settings: `${mainurl}v1/settings/get_setting_list`,
  add_edit_settings: `${mainurl}v1/settings/add_edit_setting`,
  delete_settings: `${mainurl}v1/settings/delete_setting`,
  get_setting_types: `${mainurl}v1/settings/get_setting_types`,
  get_area_units: `${mainurl}v1/crm/area_unit/get_property_area_units`,
  get_blogs: `${mainurl}v1/crm/general_blog/get_blogs`,
  add_edit_blogs: `${mainurl}v1/crm/general_blog/add_edit_blog`,
  delete_blogs: `${mainurl}v1/crm/general_blog/delete_blog`,
  get_blogs_by_slug: `${mainurl}v1/crm/general_blog/get_blog_by_slug`,
  get_city_state_conditional: `${mainurl}v1/crm/properties/get_city_state`,
  get_terms_conditions: `${mainurl}v1/crm/company_policy/get_terms_conditions`,
  add_edit_terms_conditions: `${mainurl}v1/crm/company_policy/add_edit_term_condition`,
  delete_terms_conditions: `${mainurl}v1/crm/company_policy/delete_term_condition`,
  get_terms_by_id: `${mainurl}v1/crm/company_policy/get_term_condition_by_id`, // up on discussion
  get_privacy_policy: `${mainurl}v1/crm/company_policy/get_privacy_policies`,
  add_edit_privacy_policy: `${mainurl}v1/crm/company_policy/add_edit_privacy_policy`,
  delete_privacy_policy: `${mainurl}v1/crm/company_policy/delete_privacy_policy`,
  get_contacts: `${mainurl}v1/contact/get_contacts`,
  add_best_property: `${mainurl}v1/crm/properties/update_is_best_property`,
  get_faq_list: `${mainurl}v1/crm/faq/get_faqs`,
  get_faq_by_slug: `${mainurl}v1/crm/faq/get_faq_by_slug`,
  delete_faq: `${mainurl}v1/crm/faq/delete_faq`,
  add_edit_faq: `${mainurl}v1/crm/faq/add_edit_faq`,
  get_faq_Category_list: `${mainurl}v1/crm/faq/get_faq_category_list`,
  get_faq_category: `${mainurl}v1/crm/faq/get_faq_category`,
  add_edit_faq_category: `${mainurl}v1/crm/faq/add_edit_faq_category`,
  delete_faq_category: `${mainurl}v1/crm/faq/delete_faq_category`,
  delete_contacts: `${mainurl}v1/contact/delete_contact`,
  update_review_status: `${mainurl}v1/properties/update_review_status`,
  get_trash_contacts: `${mainurl}v1/contact/get_trash_contacts`,
  get_leads: `${mainurl}v1/crm/leads/get_leads`,
  get_leads_types: `${mainurl}v1/crm/leads/get_lead_types`,
  add_edit_leads: `${mainurl}v1/crm/leads/add_edit_lead`,
  delete_leads: `${mainurl}v1/crm/leads/delete_lead`,
  restore_contacts: `${mainurl}v1/contact/restore_contact`,
  permannetly_delete_contacts: `${mainurl}v1/contact/force_delete_contact`,
  send_tour_message: `${mainurl}v1/tour_request/tour_request_confirmation`,
  send_contact_message: `${mainurl}v1/contact/contact_us_confirmation`,
  get_email_templates: `${mainurl}v1/crm/email_template/get_email_templates`,
  add_edit_email_template: `${mainurl}v1/crm/email_template/add_edit_email_template`,
  delete_email_template: `${mainurl}v1/crm/email_template/delete_email_template`,
  change_email_template_status: `${mainurl}v1/crm/email_template/update_email_template_status`,
  get_form_types: `${mainurl}v1/crm/email_template/get_form_types`,
  add_edit_email_template: `${mainurl}v1/crm/email_template/add_edit_email_template`,
  change_privacy_status: `${mainurl}v1/crm/company_policy/update_policy_status`,
  change_terms_status: `${mainurl}v1/crm/company_policy/update_term_status`,
  get_setting_tabs: `${mainurl}v1/settings/get_setting_types`,
  get_setting_main: `${mainurl}v1/settings/get_settings_by_type`,
  save_setting_main: `${mainurl}v1/settings/add_edit_multiple_setting`,
  toggle_best_feature_list: `${mainurl}v1/feature/update_is_best`,
  get_listing_status: `${mainurl}v1/crm/properties/get_listing_status`,
  get_specifications: `${mainurl}v1/crm/properties/get_specifications`,
  get_twoStepToggle: `${mainurl}v1/users/get_two_factor_auth`,
  postSettingToggle: `${mainurl}v1/users/two_factor_auth`,
  verifyOTP: `${mainurl}v1/users/verify_otp`,
  get_tour_inquiry_types: `${mainurl}v1/tour_request/get_tour_request_types`,
  get_states_for_add_proeprty: `${mainurl}v1/crm/properties/get_agent_state`,
  get_cities_for_add_proeprty: `${mainurl}v1/crm/properties/get_agent_city`,
  get_crm_logo_favicon: `${mainurl}v1/setting_for_web/get_company_logo`,

  // VALUATION TOOL
  get_valuation_tool: `${mainurl}v1/crm/valuation_tool/get_valuation_tools`,
  add_valuation_tool: `${mainurl}v1/valuation_tool/add_edit_valuation_tool`,
  delete_valuation_tool: `${mainurl}v1/crm/valuation_tool/delete_valuation_tool`,
  get_area_units_valuation: `${mainurl}v1/crm/with_out_auth/get_area_units`,
  get_area_units_valuation_types: `${mainurl}v1/crm/properties/get_property_types`,
  get_valuation_states: `${mainurl}v1/crm/with_out_auth/get_state`,
  get_valuation_cities: `${mainurl}v1/crm/with_out_auth/get_state_city`,
  get_valuation_data_for_email: `${mainurl}v1/crm/email_template/get_email_templates_by_id`,
  send_valuation_message: `${mainurl}v1/crm/valuation_tool/send_valuation_inquiry_reply`,

  // ADVANCE FILTER
  get_advance_filter_price_range: `${mainurl}v1/crm/properties/get_filter_price_range`,
  save_sub_categories: `${mainurl}v1/feature_category/add_edit_feature_sub_category`,
  get_sub_categories: `${mainurl}v1/feature_category/get_feature_sub_category`,
  crm_settings: `${mainurl}v1/setting_for_web/get_selected_settings_for_property`,

  // DASHBOARD PAGE APIS
  get_dashboard_listings: `${mainurl}v1/crm/dashboard/get_listing_lead_featured_property`,
  get_properties_for_graph: `${mainurl}v1/crm/dashboard/get_top_five_properties`,
  get_performance_chart: `${mainurl}v1/crm/dashboard/get_weekly_lead_growth`,
  get_recent_activities: `${mainurl}v1/crm/dashboard/top_log_types`,
  get_recent_log_types: `${mainurl}v1/crm/dashboard/all_log_types`,
  get_recent_activity_page: `${mainurl}v1/crm/dashboard/activity_logs`,
  // DASHBOARD PAGE APIS

  // dashboard apis

  // USER
  login: `${mainurl}v1/users/login`,
  register: `${mainurl}v1/users/sign_up`,
  otp_verify: `${mainurl}v1/users/verify_otp`,
  send_forgot_password: `${mainurl}v1/users/forgot_password`,
  update_profile: `${mainurl}v1/users/update_profile`,
  update_profile_picture: `${mainurl}v1/users/update_profile_picture`,
  update_password: `${mainurl}v1/users/change_password`,
  get_user_portfolio: `${mainurl}v1/users/get_user_portfolio`,
  invite_list: `${mainurl}v1/users/invite_list`,
  invite_user: `${mainurl}v1/users/invite_user`,
  updateforgotpassword: `${mainurl}v1/users/change_forgot_password`,
  ////////////////////////////////////////////////////////////////////////////////////////////

  // role_permission
  get_roles: `${mainurl}v1/role_permission/get_roles`,
  get_projects: `${mainurl}v1/role_permission/get_projects`,
  sideBar: `${mainurl}v1/role_permission/get_role_permission_by_user`,
  getRoles: `${mainurl}v1/role_permission/get_role_permission_and_types`,
  get_permissions: `${mainurl}v1/role_permission/get_permissions`,
  add_role_with_per_and_type: `${mainurl}v1/role_permission/add_role_with_per_and_type`,
  ////////////////////////////////////////////////////////////////////////////////////////////

  //USER MANAGEMENT
  get_users: `${mainurl}v1/users/get_users`,
  edit_user: `${mainurl}v1/users/edit_user`,
  update_status: `${mainurl}v1/users/update_status`,
  get_user_by_invite: `${mainurl}v1/project/get_user_by_invite`,
  invite_single_user: `${mainurl}v1/users/invite_single_user`,
  ////////////////////////////////////////////////////////////////////////////////////////////

  //PROJECTS
  get_all_project: `${mainurl}v1/project/get_all_project`,
  get_project_by_id: `${mainurl}v1/project/get_project_by_id`,
  get_project_type: `${mainurl}v1/project/get_project_type`,
  get_project_type_statuses: `${mainurl}v1/project/get_project_type_statuses`,
  get_project_manager: `${mainurl}v1/project/get_project_manager`,
  get_group: `${mainurl}v1/project/get_group`,
  get_all_colors: `${mainurl}v1/project/get_all_colors`,
  get_working_day: `${mainurl}v1/days/get_working_day`,
  add_edit_group: `${mainurl}v1/project/add_edit_group`,
  add_edit_project: `${mainurl}v1/project/add_edit_project`,
  upload_policy_documents: `${mainurl}v1/project/upload_policy_documents`,
  get_existing_user_list: `${mainurl}v1/users/get_existing_user_list`,
  invite_bulk_user: `${mainurl}v1/users/invite_bulk_user`,
  resand_invite: `${mainurl}v1/users/resand_invite`,
  cancel_invite: `${mainurl}v1/users/cancel_invite`,
  get_users_by_project_id: `${mainurl}v1/project/get_users_by_project_id`,
  delete_project: `${mainurl}v1/project/delete_project`,
  ////////////////////////////////////////////////////////////////////////////////////////////

  // SUB PROJECT
  get_sub_projects: `${mainurl}v1/project/get_sub_projects`,
  get_all_project_dropdown: `${mainurl}v1/project/get_all_project_dropdown`,
  add_edit_sub_project: `${mainurl}v1/project/add_edit_sub_project`,
  delete_sub_project: `${mainurl}v1/project/delete_sub_project`,
  ////////////////////////////////////////////////////////////////////////////////////////////

  // SUB PROJECT TASK
  get_sub_project_task: `${mainurl}v1/project/get_sub_project_task`,
  delete_task: `${mainurl}v1/task/delete_task`,
  get_conditions: `${mainurl}v1/resource/get_conditions`,
  get_units: `${mainurl}v1/resource/get_units`,
  get_activities: `${mainurl}v1/resource/get_activities`,
  get_depreciations: `${mainurl}v1/resource/get_depreciations`,
  get_confirmations: `${mainurl}v1/resource/get_confirmations`,
  get_categories: `${mainurl}v1/resource/get_categories`,
  add_edit_task: `${mainurl}v1/task/add_edit_task`,
  import_task: `${mainurl}v1/task/import`,
  get_my_current_import: `${mainurl}v1/task/get_my_current_import`,
  update_qty_and_notes: `${mainurl}v1/task/update_qty_and_notes`,
  get_subproject_filters: `${mainurl}v1/task/get_subproject_filters`,
  ////////////////////////////////////////////////////////////////////////////////////////////

  // UPLOAD LIST
  get_my_files: `${mainurl}v1/task/get_my_files`
  ////////////////////////////////////////////////////////////////////////////////////////////
};
